var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusiness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2128 20.7778H5.78725C4.92388 20.7762 4.09633 20.4325 3.48583 19.822C2.87533 19.2115 2.53164 18.384 2.53003 17.5206V7.9445C2.53175 7.41093 2.66478 6.88598 2.91736 6.41598C3.16995 5.94598 3.53433 5.54537 3.97836 5.2495L9.1667 1.77228C9.70692 1.40339 10.3459 1.20605 11 1.20605C11.6542 1.20605 12.2931 1.40339 12.8334 1.77228L18.0461 5.2495C18.4868 5.54746 18.8476 5.94898 19.0969 6.41885C19.3462 6.88872 19.4764 7.41258 19.4761 7.9445V17.5206C19.4745 18.385 19.13 19.2135 18.5182 19.8242C17.9064 20.4349 17.0772 20.7778 16.2128 20.7778ZM11 2.52395C10.6148 2.52502 10.2385 2.63982 9.91836 2.85395L4.69947 6.33117C4.43372 6.50841 4.21559 6.74823 4.06428 7.02955C3.91296 7.31088 3.83309 7.62507 3.8317 7.9445V17.5206C3.8317 18.0393 4.03773 18.5367 4.40446 18.9034C4.7712 19.2701 5.26861 19.4762 5.78725 19.4762H16.2128C16.7315 19.4762 17.2289 19.2701 17.5956 18.9034C17.9623 18.5367 18.1684 18.0393 18.1684 17.5206V7.9445C18.169 7.623 18.0901 7.30634 17.9387 7.02272C17.7873 6.7391 17.5681 6.49733 17.3006 6.31895L12.0817 2.85395C11.7617 2.63949 11.3853 2.52465 11 2.52395Z",
    fill: "#181A20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3905 16.2128H13.6033V17.5144H8.3905V16.2128Z",
    fill: "#181A20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default __webpack_public_path__ + "static/media/business.083bbc5700e9fdf228eedb923e4f8402.svg";
export { ForwardRef as ReactComponent };